import RecommendedExtrasAlertContent from './RecommendedExtrasAlertContentContainer';

export default RecommendedExtrasAlertContent;
